import screendevicesrequest from '@/model/requests/screendevicesrequest';
import { requestResponse, requestStream, setToken } from './rsocketutils/rsocket.service'
import subscriberequest from '@/model/requests/subscriberequest';
import debugrequest from '@/model/requests/debugrequest';
import { NODE_CONTROL, requestResponseMQTT, requestStreamMQTT, setMQTTToken, simpleMQTTAuth, subscribe, unsubscribe } from './mqttutils/mqttservice';
import clientconfig from './service.utils';
import debuglogfilerequest from '@/model/requests/debuglogfilerequest';
import debuglevelrequest from '@/model/requests/debuglevelrequest';

class AuthService {
  // eslint-disable-next-line
  getallusers(token: string, completeCallback: (data: string) => void, errorCallback: (data: any) => void) {
    if (clientconfig.clientType) {
      requestStreamMQTT("admin/users", "", completeCallback)
    }
    else {
      requestStream({
      }, "admin/users/" + token, completeCallback, errorCallback);
    }

  }
  getallsessions(token: string, completeCallback: (data: string) => void, errorCallback: (data: any) => void) {
    if (clientconfig.clientType) {
      requestStreamMQTT("admin/sessions", "", completeCallback)
    }
    else {
      requestStream({
      }, "admin/sessions/" + token, completeCallback, errorCallback);
    }
  }
  getalldevices(token: string, completeCallback: (data: string) => void, errorCallback: (data: any) => void) {
    if (clientconfig.clientType) {
      requestStreamMQTT("session/devices", "", completeCallback)
    }
    else {
      requestStream({
      }, "session/devices/" + token, completeCallback, errorCallback);
    }
  }
  getscreendevices(request: screendevicesrequest, responseCallback: (data: string) => void, errorCallback: (data: string) => void) {
    if (clientconfig.clientType) {
      requestResponseMQTT(request, 'session/screendevices', responseCallback, errorCallback);
    }
    else {
      requestResponse(request, 'session/screendevices', responseCallback, errorCallback);
    }
  }
  login(username: string, password: string, completeCallback: (data: string) => void, errorCallback: (data: any) => void) {
    console.log("login")
    if (clientconfig.clientType) {
      simpleMQTTAuth(username, password);
      requestResponseMQTT({
        username: username,
        password: password
      }, "user/signin", completeCallback, errorCallback)
    }
    else {
      requestResponse({
        username: username,
        password: password
      }, "user/signin", completeCallback, errorCallback);
    }
  }
  auth(username: string, password: string, completeCallback: (data: string) => void, errorCallback: (data: any) => void) {
    if (clientconfig.clientType) {
      requestResponseMQTT({
        username: username,
        password: password
      }, "user/auth", completeCallback, errorCallback)
    }
    else {
      requestResponse({
        username: username,
        password: password
      }, "user/auth", completeCallback, errorCallback);
    }
  }
  update(id: number, username: string, email: string, password: string,
    // eslint-disable-next-line
    userpassword: string, completeCallback: (data: any) => void,
    // eslint-disable-next-line
    errorCallback: (data: any) => void) {
    if (clientconfig.clientType) {
      requestResponseMQTT({
        id: id,
        username: username,
        email: email,
        password: password,
        userpassword: userpassword
      }, "user/update", completeCallback, errorCallback)
    }
    else {
      requestResponse({
        id: id,
        username: username,
        email: email,
        password: password,
        userpassword: userpassword
      }, "user/update", completeCallback, errorCallback)
    }
  }
  // eslint-disable-next-line
  register(username: string, email: string, password: string, userpassword: string, completeCallback: (data: any) => void, errorCallback: (data: any) => void) {
    if (clientconfig.clientType) {
      requestResponseMQTT({
        username: username,
        email: email,
        password: password,
        userpassword: userpassword
      }, "user/signup", completeCallback, errorCallback)
    }
    else {
      requestResponse({
        username: username,
        email: email,
        password: password,
        userpassword: userpassword
      }, "user/signup", completeCallback, errorCallback)
    }
  }
  clientdisconnect(token: string, uuid: string,
    completeCallback: (data: any) => void, errorCallback: (data: any) => void) {
    if (clientconfig.clientType) {
      requestResponseMQTT({
        token: token,
        uuid: uuid
      }, "user/logout", completeCallback, errorCallback);
    }
    else {
      requestResponse({
        token: token,
        uuid: uuid
      }, "user/logout", completeCallback, errorCallback);
    }
  }
  // eslint-disable-next-line
  reset(email: string, completeCallback: (data: string) => void, errorCallback: (data: any) => void) {
    if (clientconfig.clientType) {
      requestResponseMQTT({
        email: email
      }, "user/reset", completeCallback, errorCallback);
    }
    else {
      requestResponse({
        email: email
      }, "user/reset", completeCallback, errorCallback);
    }

  }
  updatedebug(request: debugrequest, completeCallback: (data: string) => void, errorCallback: (data: any) => void) {
    if (clientconfig.clientType) {
      requestResponseMQTT({
        username: request.username,
        debug: request.debug
      }, "admin/debuguser", completeCallback, errorCallback);
    }
    else {
      requestResponse({
        username: request.username,
        debug: request.debug
      }, "admin/debuguser", completeCallback, errorCallback);
    }
  }
  debuglevel(request: debuglevelrequest, completeCallback: (data: string) => void, errorCallback: (data: any) => void) {
    if (clientconfig.clientType) {
      requestResponseMQTT(request,NODE_CONTROL.COMMANDS.DEBUG_LEVEL, completeCallback, errorCallback);
    }
    else {
      requestResponse(request, "admin/debuglevel", completeCallback, errorCallback);
    }
  }
  getdevicelog(request: debuglogfilerequest, completeCallback: (data: string) => void, errorCallback: (data: any) => void) {
    if (clientconfig.clientType) {
      requestResponseMQTT(request,NODE_CONTROL.COMMANDS.GET_LOG, completeCallback, errorCallback);
    }
    else {
      requestResponse(request, "admin/getdevicelog", completeCallback, errorCallback);
    }
  }
  getdebug(request: debugrequest, completeCallback: (data: string) => void, errorCallback: (data: any) => void) {
    if (clientconfig.clientType) {
      requestResponseMQTT({
        username: request.username,
        debug: request.debug
      }, "admin/getdebug", completeCallback, errorCallback);
    }
    else {
      requestResponse({
        username: request.username,
        debug: request.debug
      }, "admin/getdebug", completeCallback, errorCallback);
    }
  }
  cleardebug(request: debugrequest, completeCallback: (data: string) => void, errorCallback: (data: any) => void) {
    if (clientconfig.clientType) {
      requestResponseMQTT({
        username: request.username,
        debug: request.debug
      }, "admin/cleardebug", completeCallback, errorCallback);
    }
    else {
      requestResponse({
        username: request.username,
        debug: request.debug
      }, "admin/cleardebug", completeCallback, errorCallback);
    }
  }


  subscribe(request: subscriberequest, completeCallback: (data: string) => void, errorCallback: (data: any) => void) {
    if (clientconfig.clientType) {
      console.log("Subscribe:", request.subscription)
      subscribe(request.subscription)
    }
    else {
      requestResponse(request, "user/subscribe", completeCallback, errorCallback);
    }
  }
  unsubscribe(request: subscriberequest, completeCallback: (data: string) => void, errorCallback: (data: any) => void) {
    if (clientconfig.clientType) {
      console.log("Unsubscribe:", request.subscription)
      unsubscribe(request.subscription)
    }
    else {
      requestResponse(request, "user/unsubscribe", completeCallback, errorCallback);
    }
  }

  logout() {
    localStorage.removeItem('user');
    setToken(null);
  }
  setToken(token: string) {
    if (clientconfig.clientType == 1) {
      setMQTTToken(token)
    }
    else {
      setToken(token)
    }
  }



  updatehistorysettings(token: string, savehistory: boolean, storageperiod: number,
    completeCallback: (data: any) => void,
    errorCallback: (data: any) => void) {
    if (clientconfig.clientType) {
      requestResponseMQTT({
        token: token,
        savehistory: savehistory,
        storageperiod: storageperiod
      }, "user/updatehistory", completeCallback, errorCallback)
    }
    else {
      requestResponse({
        token: token,
        savehistory: savehistory,
        storageperiod: storageperiod
      }, "user/updatehistory", completeCallback, errorCallback)
    }
  }
  updatescreenssettings(token: string, savescreens: boolean, mainscreen: string,
    completeCallback: (data: any) => void,
    errorCallback: (data: any) => void) {
    if (clientconfig.clientType) {
      requestResponseMQTT({
        token: token,
        savescreens: savescreens,
        mainscreen: mainscreen
      }, "user/updatescreens", completeCallback, errorCallback)
    }
    else {
      requestResponse({
        token: token,
        savescreens: savescreens,
        mainscreen: mainscreen
      }, "user/updatescreens", completeCallback, errorCallback)
    }

  }
  updatelocalesettings(token: string, locale: string,
    completeCallback: (data: any) => void,
    errorCallback: (data: any) => void) {
    if (clientconfig.clientType) {
      requestResponseMQTT({
        token: token,
        locale: locale
      }, "user/updatelocale", completeCallback, errorCallback)
    }
    else {
      requestResponse({
        token: token,
        locale: locale
      }, "user/updatelocale", completeCallback, errorCallback)
    }
  }
  updatetariff(token: string, id: number, tariff: string, completeCallback: (data: any) => void,
    // eslint-disable-next-line
    errorCallback: (data: any) => void) {
    if (clientconfig.clientType) {
      requestResponseMQTT({
        token: token,
        id: id,
        tariff: tariff
      }, "admin/updatetariff", completeCallback, errorCallback)
    }
    else {
      requestResponse({
        token: token,
        id: id,
        tariff: tariff
      }, "admin/updatetariff", completeCallback, errorCallback)
    }
  }
  updateenddate(token: string, id: number, enddate: number, completeCallback: (data: any) => void,
    // eslint-disable-next-line
    errorCallback: (data: any) => void) {
    if (clientconfig.clientType) {
      requestResponseMQTT({
        token: token,
        id: id,
        enddate: enddate
      }, "admin/updateenddate", completeCallback, errorCallback)
    }
    else {
      requestResponse({
        token: token,
        id: id,
        enddate: enddate
      }, "admin/updateenddate", completeCallback, errorCallback)
    }
  }
  updateallenddate(token: string, enddate: number, completeCallback: (data: any) => void,
    // eslint-disable-next-line
    errorCallback: (data: any) => void) {
    if (clientconfig.clientType) {
      requestResponseMQTT({
        token: token,
        enddate: enddate
      }, "admin/updateallenddate", completeCallback, errorCallback)
    }
    else {
      requestResponse({
        token: token,
        enddate: enddate
      }, "admin/updateallenddate", completeCallback, errorCallback)
    }
  }

  deleteuser(token: string, id: number, completeCallback: (data: any) => void,
    // eslint-disable-next-line
    errorCallback: (data: any) => void) {
    if (clientconfig.clientType) {
      requestResponseMQTT({
        token: token,
        id: id,
      }, "admin/deleteuser", completeCallback, errorCallback)
    }
    else {
      requestResponse({
        token: token,
        id: id,
      }, "admin/deleteuser", completeCallback, errorCallback)
    }
  }
}
export default new AuthService();